import { render, staticRenderFns } from "./code-editors.vue?vue&type=template&id=804e5978"
import script from "./code-editors.vue?vue&type=script&lang=js"
export * from "./code-editors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports